export class UserSession {
  constructor(
    private userToken: string,
  ) {}

  get token() {
    return this.userToken;
  }
}

